<div data-testid="file-upload-container" class="file-upload-container relative">
  <!-- File Upload Area -->
  <button
    data-testid="file-upload-dropzone-btn"
    type="button"
    class="upload-area"
    [class.dragover]="isDragOver && !disabled"
    [class.disabled]="disabled"
    [class.has-video]="uploadedFile?.isVideo"
    (dragover)="!disabled && onDragOver($event)"
    (dragleave)="!disabled && onDragLeave($event)"
    (drop)="!disabled && onDrop($event)"
    (click)="!disabled && fileInput.click()"
  >
    @if (isValidatingVideo) {
      <div class="upload-placeholder">
        <i class="pi pi-spin pi-spinner text-2xl text-gray-400 mb-2"></i>
        <p class="text-sm text-gray-600 mb-1">
          {{ "common.form.placeholders.validating_file" | translate }}
        </p>
      </div>
    } @else if (!uploadedFile) {
      <div class="upload-placeholder">
        <span class="material-symbols-outlined text-2xl text-gray-400 mb-2"
          >upload</span
        >
        <p class="text-sm text-gray-600 mb-1">
          {{
            disabled
              ? ("common.form.placeholders.no_file_uploaded" | translate)
              : (placeholder | translate)
          }}
        </p>
        <p class="text-xs text-gray-500">
          {{
            disabled
              ? ""
              : acceptedTypes
                ? ("common.form.placeholders.accepted" | translate) +
                  ": " +
                  (acceptedTypes | translate)
                : ("common.form.placeholders.all_files_accepted" | translate)
          }}
        </p>
      </div>
    } @else {
      <div class="uploaded-file">
        @if (uploadedFile.isVideo) {
          @if (uploadedFile.previewUrl) {
            <video
              data-testid="file-upload-preview-video"
              [src]="uploadedFile.previewUrl"
              class="file-preview-video"
              preload="metadata"
              muted
              controls
              (error)="onImageError($event)"
            ></video>
          } @else {
            <div data-testid="file-upload-file-icon" class="file-icon">
              <span class="material-symbols-outlined text-2xl text-gray-400"
                >movie</span
              >
            </div>
          }
        } @else if (uploadedFile.previewUrl) {
          <img
            data-testid="file-upload-preview-image"
            [src]="uploadedFile.previewUrl"
            [alt]="uploadedFile.fileName"
            class="file-preview"
            (error)="onImageError($event)"
            (load)="onImageLoad($event)"
          />
        } @else {
          <div data-testid="file-upload-file-icon" class="file-icon">
            @if (isExcelFile(uploadedFile.fileName)) {
              <span class="material-symbols-outlined text-2xl text-green-600"
                >table_chart</span
              >
            } @else {
              <span class="material-symbols-outlined text-2xl text-gray-400"
                >description</span
              >
            }
          </div>
        }
        <!-- Only show file info for newly uploaded files (not existing images) -->
        @if (uploadedFile.fileSize && uploadedFile.fileSize > 0) {
          <div data-testid="file-upload-file-info" class="file-info">
            <p data-testid="file-upload-file-name" class="file-name">
              {{
                uploadedFile.fileName ||
                  ("common.form.placeholders.unknown" | translate)
              }}
            </p>
            <p data-testid="file-upload-file-size" class="file-size">
              {{ formatFileSize(uploadedFile.fileSize) }}
            </p>
          </div>
        }
      </div>
    }
  </button>

  <!-- Hidden File Input -->
  <input
    #fileInput
    data-testid="file-upload-input"
    type="file"
    [accept]="accept"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="!disabled && onFileSelected($event)"
    class="hidden"
  />
  <!-- Remove button: show when not disabled -->
  @if (uploadedFile && !disabled) {
    <button
      data-testid="file-upload-remove-btn"
      type="button"
      class="remove-image-btn"
      (click)="uploadedFile.isExisting ? removeExistingImage() : removeFile()"
      [title]="'common.actions.remove' | translate"
    >
      ×
    </button>
  }

  <!-- Error Message -->
  @if (errorMessage) {
    <div
      data-testid="file-upload-error-message"
      class="error-message text-red-500 text-xs mt-1"
    >
      {{ errorMessage | translate: errorParams }}
    </div>
  }
</div>
